import { forwardRef, ReactNode, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { cn } from 'utils/helpers';
import SideBarButton from 'components/sidebar/sidebarButton';

type LayoutProps = {
  children: ReactNode;
  onSubmit?: () => void;
  loading?: boolean;
};

const SettingsLayout = forwardRef<(() => void) | null, LayoutProps>(
  ({ children }, ref) => {
    const navigate = useNavigate();
    const [menuVisible, setMenuVisible] = useState(false);

    return (
      <div className="flex items-center justify-center text-white bg-[#0a0118]">
        <div
          className={cn(
            'flex flex-col min-h-screen w-full h-full max-w-md p-5',
          )}
        >
          <header className="flex justify-between items-center w-full mt-5">
            <ChevronLeft
              className="cursor-pointer"
              onClick={() => navigate(-1)}
            />

            <div className="flex items-center justify-center">
              <p className="text-[1.25rem] font-bold uppercase Westmount">
                Settings
              </p>
            </div>

            <button
              onClick={() => setMenuVisible(!menuVisible)}
              className="flex items-center"
            >
              <SideBarButton />
            </button>
          </header>
          {children}
        </div>
      </div>
    );
  },
);

SettingsLayout.displayName = 'SettingsLayout';

export default SettingsLayout;
